

























































































































































































































































































// 接口和其他
import json2csv from "json2csv";
import {
  getHomeworkListApi,
  getHomeworkDataApi,
  getHomeworkTeacherListApi,
} from "@/api/statistics";
import { Vue, Component } from "vue-property-decorator";
import { createOperationLogApi } from "@/api/store";
import { dateFormat } from "@/utils/timeFormat";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import { roundNumbers } from "@/utils/roundNumbers";

@Component({
  methods: { roundNumbers },
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    date: [],
  };
  allTableData: any[] = [];
  exporting: boolean = false;
  pageTableData: any[] = [];
  currentSortOption: any = {
    order: "descending",
    prop: "",
  };
  practiceStatistics: any = [];
  checkTabs: number = 1;
  tableData: any = [];
  tableTeacherData: any = [];
  mounted() {
    this.searchInfo.date = [
      dateFormat("YYYY-mm-dd", new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
      dateFormat("YYYY-mm-dd", new Date().getTime()),
    ];
    this.handleSearch();
  }
  handleSearch() {
    if (this.searchInfo.date.length === 2) {
      getHomeworkDataApi({
        start_date: this.searchInfo.date[0],
        end_date: this.searchInfo.date[1],
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.practiceStatistics = [];
          const d = res.data;
          const arr1: any = {
            arr: [
              {
                name: "上课课次数",
                num: d.lesson_num,
                popover: "日期范围内,上课的节数",
              },
              {
                name: "到课学员数",
                num: d.roll_call_attend_student_num,
                popover: "日期范围内,点名到课的学员人次数,包含到课/迟到",
              },
              {
                name: "发布作业数",
                num: d.should_commit_num,
                popover: "日期范围内,老师发布的作业份数",
              },
              {
                name: "作业发布率",
                num: roundNumbers(d.homework_publish_rate) + "%",
                popover: "作业发布率=发布作业数/到课学员数",
              },
              {
                name: "授课老师数",
                num: d.lesson_teacher_num,
                popover: "日期范围内,上课的老师人数",
              },
              {
                name: "应提交作业数",
                num: d.should_commit_num,
                popover: "日期范围内,老师发布的作业份数",
              },
              {
                name: "已提交作业数",
                num: d.committed_num,
                popover: "日期范围内,老师发布的作业,学员已提交的作业份数",
              },
            ],
          };
          const arr2: any = {
            arr: [
              {
                name: "未提交作业数",
                num: d.not_commit_num,
                popover: "日期范围内,老师发布的作业,学员已提交的作业份数",
              },
              {
                name: "已批改作业数",
                num: d.corrected_num,
                popover:
                  "日期范围内,老师发布的作业,学员提交后老师已批改的作业份数",
              },
              {
                name: "未批改作业数",
                num: d.be_correct_num,
                popover:
                  "日期范围内,老师发布的作业,学员提交后老师未批改的作业份数",
              },
              {
                name: "超24小时未批改",
                num: d.over_one_day_be_correct_num,
                popover:
                  "日期范围内,老师发布的作业,学员提交后老师超过24小时未批改的作业份数",
              },
              {
                name: "应发布点评数",
                num: d.roll_call_attend_student_num,
                popover: "日期范围内,点名到课的学员人次数,包含到课/迟到",
              },
              {
                name: "发布点评数",
                num: d.lesson_comment_finish_count,
                popover:
                  "日期范围内,点名到课学员人次数中,老师已发布点评的学员人次数",
              },
              {
                name: "老师点评率",
                num: roundNumbers(d.lesson_comment_finish_rate) + "%",
                popover: "老师发布点评率=发布点评数/应发布点评数",
              },
            ],
          };
          this.practiceStatistics.push(arr1, arr2);
        }
      });
      getHomeworkListApi({
        start_date: this.searchInfo.date[0],
        end_date: this.searchInfo.date[1],
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.tableData = [];
          for (const key in res.data) {
            res.data[key].date = key;
            // 作业发布率格式化
            res.data[key].homework_publish_rate_str =
              roundNumbers(res.data[key].homework_publish_rate) + "%";
            // 点评率格式化
            res.data[key].lesson_comment_finish_rate_str =
              roundNumbers(res.data[key].lesson_comment_finish_rate) + "%";
            // 用于导出处理的特殊字段
            res.data[key].should_commit_num_2 = res.data[key].should_commit_num;
            res.data[key].roll_call_attend_student_num_2 =
              res.data[key].roll_call_attend_student_num;

            this.tableData.push(res.data[key]);
          }
          this.handleSortChange({
            order: "descending",
            prop: "date",
          });
        }
      });
      getHomeworkTeacherListApi({
        start_date: this.searchInfo.date[0],
        end_date: this.searchInfo.date[1],
      }).then((res: any) => {
        res.data.list.map((item: any) => {
          // 作业发布率格式化
          item.homework_publish_rate_str =
            roundNumbers(item.homework_publish_rate) + "%";
          // 点评率格式化
          item.lesson_comment_finish_rate_str =
            roundNumbers(item.lesson_comment_finish_rate) + "%";
          // 用于导出处理的特殊字段
          item.should_commit_num_2 = item.should_commit_num;
          item.roll_call_attend_student_num_2 =
            item.roll_call_attend_student_num;
        });
        this.tableTeacherData = res.data.list;
      });
    }
  }
  sortList(list: any[]) {
    const copy = [...list];
    if (this.currentSortOption.prop === "date") {
      // 日期字符串排序
      copy.sort((a: any, b: any) => {
        return (
          new Date(b[this.currentSortOption.prop]).getTime() -
          new Date(a[this.currentSortOption.prop]).getTime()
        );
      });
    } else {
      copy.sort((a: any, b: any) => {
        return (
          Number(b[this.currentSortOption.prop]) -
          Number(a[this.currentSortOption.prop])
        );
      });
    }
    if (this.currentSortOption.order === "ascending") {
      copy.reverse();
    }
    return copy;
  }
  handleSortChange(data: any) {
    this.currentSortOption = {
      order: data.order,
      prop: data.prop,
    };
    this.tableData = this.sortList(this.tableData);
  }
  // 授课老师数据排序
  handleSortChangeTeacher(data: any) {
    this.currentSortOption = {
      order: data.order,
      prop: data.prop,
    };
    this.tableTeacherData = this.sortList(this.tableTeacherData);
  }
  // 导出
  handleExport() {
    if (this.exporting) {
      return false;
    }
    this.exporting = true;
    try {
      let result;
      if (this.checkTabs === 1) {
        result = json2csv.parse(
          [
            {
              date: "查询时间",
              lesson_num: "上课次数",
              roll_call_attend_student_num: "到课学员数",
              should_commit_num: "发布作业数",
              homework_publish_rate_str: "作业发布率",
              lesson_teacher_num: "授课老师数",
              should_commit_num_2: "应提交作业数",
              committed_num: "已提交作业数",
              not_commit_num: "未提交作业数",
              corrected_num: "已批改作业数",
              be_correct_num: "未批改作业数",
              over_one_day_be_correct_num: "超24小时未批改",
              roll_call_attend_student_num_2: "应发布点评数",
              lesson_comment_finish_count: "发布点评数",
              lesson_comment_finish_rate_str: "老师点评率",
            },
            ...this.tableData,
          ],
          {
            fields: [
              "date",
              "lesson_num",
              "roll_call_attend_student_num",
              "should_commit_num",
              "homework_publish_rate_str",
              "lesson_teacher_num",
              "should_commit_num_2",
              "committed_num",
              "not_commit_num",
              "corrected_num",
              "be_correct_num",
              "over_one_day_be_correct_num",
              "roll_call_attend_student_num_2",
              "lesson_comment_finish_count",
              "lesson_comment_finish_rate_str",
            ],
            header: false,
          }
        );
      } else {
        result = json2csv.parse(
          [
            {
              "teacher.name": "老师名称",
              lesson_num: "上课课次数",
              roll_call_attend_student_num: "到课学员数",
              should_commit_num: "发布作业数",
              homework_publish_rate_str: "作业发布率",
              should_commit_num_2: "应提交作业数",
              committed_num: "已提交作业数",
              not_commit_num: "未提交作业数",
              corrected_num: "已批改作业数",
              be_correct_num: "未批改作业数",
              over_one_day_be_correct_num: "超24小时未批改",
              roll_call_attend_student_num_2: "应发布点评数",
              lesson_comment_finish_count: "发布点评数",
              lesson_comment_finish_rate_str: "老师点评率",
            },
            ...this.tableTeacherData,
          ],
          {
            fields: [
              "teacher.name",
              "lesson_num",
              "roll_call_attend_student_num",
              "should_commit_num",
              "homework_publish_rate_str",
              "should_commit_num_2",
              "committed_num",
              "not_commit_num",
              "corrected_num",
              "be_correct_num",
              "over_one_day_be_correct_num",
              "roll_call_attend_student_num_2",
              "lesson_comment_finish_count",
              "lesson_comment_finish_rate_str",
            ],
            header: false,
          }
        );
      }
      //非IE浏览器
      const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
      //使用a标签的download属性实现下载功能
      const link = document.createElement("a");
      link.href = encodeURI(csvContent);
      link.download =
        `${
          this.checkTabs === 1 ? "课后练习明细数据[" : "课后练习授课老师数据["
        }` +
        this.searchInfo.date[0] +
        " ~ " +
        this.searchInfo.date[1] +
        "].csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // 3秒导出间隔
      setTimeout(() => {
        this.exporting = false;
      }, 3000);
      createOperationLogApi({
        code: 10505,
        detail: "导出课后练习数据明细",
      }).then(() => {
        this.$message({
          type: "success",
          message: "导出成功",
        });
      });
    } catch (err: any) {
      this.$message({
        type: "error",
        message: err.toString(),
      });
    }
  }
}
